import { cn } from "@/lib/cn.ts";

interface SpinnerProps { size?: "sm" | "md" | "lg"; className?: string; }

const SIZES = { sm: "h-4 w-4", md: "h-6 w-6", lg: "h-8 w-8" };

export function Spinner({ size = "md", className }: SpinnerProps) {
  return (
    <div className={cn("animate-spin rounded-full border-2 border-surface-200 border-t-brand-600", SIZES[size], className)} />
  );
}
